import React, {Component, Fragment} from 'react';
import Spinner from './Spinner'
import Fab from '@material-ui/core/Fab';
import {fieldErrors, stripeErrors} from '../utils/errors'
import { graphql, navigate } from 'gatsby'
import { logEvent, pushToDataLayer } from './Analytics'
import SubscriptionModal from './LockSubscription'

import {CardElement, CardNumberElement, CardExpiryElement, CardCVCElement, injectStripe} from 'react-stripe-elements';

class PaymentFormExperiment extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            loading: false,
            disabled: false,
            stripeToken: '',
            showPopup: false
        }
    }

    async submit(ev) {
        const { errorMsg, cardName, setCardNameError } = this.props;
        setCardNameError('')
        errorMsg('')

        if (!cardName.length) return setCardNameError(fieldErrors.nameOnCard)

        this.setState({loading: true, disabled: true});

        let {token, error} = await this.props.stripe.createToken({name: cardName});
        if(error){
            errorMsg(stripeErrors[error.code]);
            this.setState({loading: false, disabled: false});
            return false;
        }

        this.setState({stripeToken: token, showPopup: true, loading: false, disabled: false})
    }

    submitDetails = (ev) => {
        const {email, accountType, phone, errorMsg, cardName, referby, campaign} = this.props;
        const {stripeToken} = this.state;
        errorMsg('')
        
        pushToDataLayer('addtocart_mixed', 'Cart', 'AddToCart', 'Mixed')
        this.setState({loading: true, disabled: true});

        const formState = {
            token: stripeToken,
            plan: accountType,
            name: cardName,
            email: email,
            phone: phone,
            location: "SE",
            campaign: campaign,
            trail: 30,
            abTests: { experimentUpgradeDialog: 1 },
            coupon: 'true',
            referby,
            origin: typeof window !== 'undefined' ? window.location.href : ''
        }
        // console.log(formState)
        fetch(`${process.env.API_URI}/users/create`, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify(formState)
        })
        .then(resp => resp.json())
        .then(resp => {
            console.log('resp', resp)
            if (resp.status === 200) {
                pushToDataLayer('addtocart_mixed', 'Purchase', 'done', 'Mixed');
                navigate(
                    '/congrats',
                    { state: {email, plan: accountType, userId: resp.userId, campaign} }
                )
            } else {
                errorMsg(resp.errorMsg);
                this.setState({loading: false, disabled: false});
            }
        })
        .catch(error => console.error(error))
        
    }
    
    render() {
        const {disabled, loading, showPopup} = this.state;
        const {setCamp, campaign, errorText} = this.props;
        console.log(campaign)
        const stripeStyle = {
            base: {
                fontSize: '16px',
                color: '#424770',
                letterSpacing: '0.025em',
                '::placeholder': {
                    color: '#aab7c4',
                },
            },
            invalid: {
                color: '#c23d4b'
            }
        };

        return (
            <Fragment>
                <div className="checkout">
                    <div className='accountFormEmail'>
                        <h4>Kortnummer</h4>
                        <CardNumberElement className="form-control"
                            onChange={this.handleChange}
                            style={stripeStyle}
                        />
                    </div>

                    <div className='accountFormEmail'>
                        <h4>MM/YY</h4>
                        <CardExpiryElement  className="form-control w-50"
                            onChange={this.handleChange}
                            style={stripeStyle}
                            placeholder="MM/YY"
                        />
                    </div>

                    <div className='accountFormEmail'>
                        <h4>CVC</h4>
                        <CardCVCElement className="form-control w-50 last-w"
                            onChange={this.handleChange}
                            style={stripeStyle}
                            placeholder="XXX"
                        />
                    </div>
                    <label className="text-error">{errorText}</label>

                    <Fab
                        variant="extended"
                        // size="small"
                        color="primary"
                        aria-label="Add"
                        className="registerButton"
                        disabled={disabled}
                        onClick={e => {
                                logEvent(
                                    `Start page register payment button`,
                                    `Start page register payment button was clicked`
                                );
                                this.submit();
                                pushToDataLayer(
                                    'userClick',
                                    'Start Page Register Payment Button',
                                    'Start Page Register Payment Button Was Clicked'
                                )
                            }
                        }
                        
                        >
                        Påbörja din gratisperiod
                    </Fab>
                    {
                        loading && (
                            <Spinner size={48}/>
                        )
                    }
                </div>
                {
                    showPopup && (
                        <SubscriptionModal setCamp={setCamp} 
                            campaign={campaign} 
                            action={() => this.submitDetails()} 
                            errorMessage={errorText}
                            buttonDisabled={disabled }
                            />
                    )
                }
            </Fragment>

        );
    }
}

export default injectStripe(PaymentFormExperiment);